import { useCallback } from "react";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import { IndustryTransitionImpactReportModal } from "../components/IndustryTransitionImpactReportModal/IndustryTransitionImpactReportModal";
import { useCrmIndustryTransitionState } from "../hooks/useHasAnyPendingCrmIndustryTransition";
import { useIndustryTransitionImpactReportModal } from "../hooks/useIndustryTransitionImpactReportModal";
import industryTrackingService from "../services/tracking/trackingService";
import { getFirstCrmWithPendingJobsTransition } from "../utils/crmJobsTransition";

export const IndustryTransitionImpactReportModalContainer = () => {
    const { phase, report, canEnroll, canRetryEnroll, handlers } = useIndustryTransitionImpactReportModal();
    const { data: crmJobsTransition } = useCrmIndustryTransitionState();

    const { close } = handlers;

    /** Distinct from the success-screen navigations below, so the dismiss metric is not inflated by them. */
    const handleDismiss = useCallback(() => {
        industryTrackingService.trackImpactReportDismiss();
        close();
    }, [close]);

    /** The dialog is portaled outside the router outlet, so navigating alone leaves it over the destination. */
    const handleViewLeadGeneration = useCallback(() => {
        industryTrackingService.trackImpactReportViewLeadGeneration();
        close();
        void siNavigator.goToAdvancedSearchPage();
    }, [close]);

    const handleGoToCrmSettings = useCallback(() => {
        industryTrackingService.trackImpactReportCrmSettings();
        close();

        const crm = getFirstCrmWithPendingJobsTransition(crmJobsTransition);

        if (crm) {
            void siNavigator.goToCrmManagementPage({ crm });
            return;
        }

        void siNavigator.goToCrmIntegrationsPage();
    }, [close, crmJobsTransition]);

    return (
        <IndustryTransitionImpactReportModal
            phase={phase}
            report={report}
            canEnroll={canEnroll}
            canRetryEnroll={canRetryEnroll}
            onEnroll={handlers.enroll}
            onRetryEnroll={handlers.retryEnroll}
            onRetryReport={handlers.retryReport}
            onClose={handleDismiss}
            onViewLeadGeneration={handleViewLeadGeneration}
            onGoToCrmSettings={handleGoToCrmSettings}
        />
    );
};
